import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { NewlyCalculatedGADDetails } from "./CalculatedGADDetails";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { ChooseAssetsToSell } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSell";
import { ChooseAssetsToSellTable } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import {
    getAssetsToSellTotalForDrawdown,
    getSellableAssets,
    getUpdatedAssetsToSell,
    showChooseAssetstoSell,
} from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ChooseAssetsToSellAssets } from "../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { RegularIncomePaymentDetails } from "./RegularIncomePaymentDetails";
import { OtherIncomePaymentDetails } from "./OtherIncomePaymentDetails";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { IncomeBankDetails } from "../../../Common/SIPP/IncomePaymentDetails/IncomeBankDetails";
import { setValueByKey } from "../../../../../../Shared/Table/Utils/TableUtils";
import { ChooseAssetsToSellFor } from "../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";

interface IIncomePaymentDetailsProps extends IProcessComponentProps {
    data: PensionContributionModel;
    type: SubAccountType;
}

interface IIncomePaymentDetailsState {
    assets: ChooseAssetsToSellAssets[];
}

export class IncomePaymentDetails extends ProcessComponent<IIncomePaymentDetailsProps, IIncomePaymentDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            assets: [],
        };
    }

    private getSellableAssets = () => {
        const params = getQueryParameters();
        const hierarchyId = params["hierarchyid"];
        SubAccountTypeHelper.getSubAccountHierarchyId(hierarchyId, SubAccountType.Npr, (subAccountHierarchyId) => {
            getSellableAssets(this.props.type, hierarchyId, subAccountHierarchyId, (data) => {
                const usedTotal = getAssetsToSellTotalForDrawdown(this.props.data?.Contribution?.DrawdownModel);
                const updateAssets = getUpdatedAssetsToSell(
                    this.props.data?.Contribution?.DrawdownModel.PensionCommencementLumpSumAllocations,
                    usedTotal,
                    data
                );
                this.setState({ assets: updateAssets });
            });
        });
    };

    componentDidMount() {
        super.componentDidMount();
        this.getSellableAssets();
    }

    private getContributionProps = (data: PensionContributionModel, onChange) => {
        return {
            data: data?.Contribution,
            onChange: (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    };

    private getDrawdownModelProps = (data: PensionContributionModel, onChange) => {
        return {
            data: data?.Contribution?.DrawdownModel,
            onChange: (v) =>
                this.onDataChange(
                    (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                    v,
                    data.Contribution,
                    "DrawdownModel"
                ),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    };

    showChooseAssetsToSellTable() {
        const { data } = this.props;
        return (
            data?.Contribution?.DrawdownModel?.IsAcrossAllAssets == false ||
            !isNullOrEmpty(data?.Contribution?.DrawdownModel?.IncomeDisinvestmentAllocations)
        );
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const drawdownType = data?.Contribution?.DrawdownModel?.DrawdownType;

        return (
            <>
                {<h2>Income payment details</h2>}

                {drawdownType === DrawdownType.Capped && (
                    <NewlyCalculatedGADDetails {...this.getContributionProps(data, onChange)} />
                )}
                {drawdownType === DrawdownType.Regular ? (
                    <RegularIncomePaymentDetails {...this.getDrawdownModelProps(data, onChange)} pensionBase={data} />
                ) : (
                    <OtherIncomePaymentDetails {...this.getDrawdownModelProps(data, onChange)} pensionBase={data} />
                )}
                {showChooseAssetstoSell(data.Contribution.DrawdownModel, ChooseAssetsToSellFor.Income) && (
                    <>
                        <hr />
                        <ChooseAssetsToSell
                            {...this.getDrawdownModelProps(data, onChange)}
                            tableKey={"IncomeDisinvestmentAllocations"}
                            reason={ChooseAssetsToSellFor.Income}
                        />
                        {this.showChooseAssetsToSellTable() && (
                            <ChooseAssetsToSellTable
                                data={data?.Contribution?.DrawdownModel?.IncomeDisinvestmentAllocations}
                                tableData={this.state.assets}
                                modelData={data?.Contribution?.DrawdownModel}
                                onRef={(ref) => this.appendChild(ref)}
                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                onChange={(v) => {
                                    this.onDataChange(
                                        (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                        { IncomeDisinvestmentAllocations: v },
                                        data.Contribution,
                                        "DrawdownModel"
                                    );
                                }}
                                processType={ProcessType.TakePensionBenefits}
                                reason={ChooseAssetsToSellFor.Income}
                            />
                        )}
                    </>
                )}
                <hr />
                <IncomeBankDetails
                    data={data?.Contribution?.DrawdownModel?.Income?.IncomePaymentAllocations || []}
                    onChange={(value) => {
                        onChange(
                            setValueByKey(data, "Contribution.DrawdownModel.Income.IncomePaymentAllocations", value)
                        );
                    }}
                    showErrorMsgPopUp={(msg, isShow) => this.props.showErrorMsgPopUp(msg, isShow)}
                    onRef={(ref) => this.appendChild(ref)}
                    allBankAccounts={data?.AllBankAccounts}
                    showPropotionOfIncome={data?.Contribution?.DrawdownModel?.Income?.TaxableIncomeRequiredInAddition}
                />
            </>
        );
    }
}
